export default __webpack_public_path__ + "img/product-widget-empty.b2a5f556.svg";